import { Component, OnInit } from '@angular/core';
import {BsModalRef} from "ngx-bootstrap/modal";
import {ReceiptService} from "../../../services/receipt.service";
import {LoaderService} from "../../../services/loader.service";
import {finalize} from "rxjs/operators";

interface IReceipt {
 id: string;
 createdAt: Date;
 updatedAt: Date;
 value: string;
}

@Component({
  selector: 'modal-receipt-details',
  templateUrl: './modal-receipt-details.component.html',
  providers: [LoaderService]
})
export class ModalReceiptDetailsComponent implements OnInit {

  item: IReceipt;
  id: string;

  constructor(public modalRef: BsModalRef,
              public loaderService: LoaderService,
              private modelService: ReceiptService) { }

  ngOnInit(): void {
    this.get();
  }

  get(): void {
    if (this.item) {
      this.loaderService.hide();
      return
    };
    this.loaderService.show();
    this.modelService.get({id: this.id})
      .pipe(finalize(() => {
        this.loaderService.hide();
      }))
      .subscribe((res: any) => {
          this.item = res;
        },
        err => {
        console.log(err);
        }
      );
  }
}
